import { mutationTypes } from '../types';
import { uiComponents, uiStates } from '../tools/viewState';
import { logger } from '../tools/logger';
import { i18n } from '@/tools/i18n';

function openPostAtIndex(store, figureIndex, mediaObjects) {
	store.commit(mutationTypes.gallerySetEntries, { mediaObjects, imageSize: store.state.imageSize });
	store.commit(mutationTypes.gallerySetIndex, figureIndex);
	store.commit(mutationTypes.viewStateSetUiState, {
		id: uiComponents.uiGallery,
		uiState: uiStates.maximised,
	});
}

function getImagesShow(mediaObjectsLength) {
	if (mediaObjectsLength < 4) return 1;
	if (mediaObjectsLength < 6) return 4;
	if (mediaObjectsLength < 9) return 6;
	return 9;
}

export default {
	init() {
		[
			...this.$el.querySelectorAll(
				'.post--gallery .post__container,[operation-type="gallery"] .post__container'
			),
		].forEach(postElement => {
			const mediaObjects = [];
			logger.log('initialized gallery thing');

			// get the mediaObjects from the store for each .post__image[media-id] in
			// the .post--gallery and add a click listener to open at that figure
			[...postElement.querySelectorAll('[media-id]')].forEach((image, figureIndex) => {
				const mediaID = image.getAttribute('media-id');
				const mediaObject = this.$store.state.currentMediaObjectMap.get(mediaID);

				if (mediaObject) {
					mediaObjects.push(mediaObject);
					image.addEventListener('click', () => openPostAtIndex(this.$store, figureIndex, mediaObjects));
				} else {
					logger.warn('could not find mediaobject with id' + mediaID);
				}
			});
			postElement.setAttribute('show-images', getImagesShow(mediaObjects.length));
			if (postElement.parentNode.classList.contains('.post--gallery')) {
				postElement.parentNode.setAttribute('show-images', getImagesShow(mediaObjects.length));
			}
			// for older gallery posts attribute has to be on post container

			// if the .post--gallery is clicked not on a .post__image, open first image
			postElement.addEventListener('click', event => {
				if (event.target.closest('[media-id]')) return;
				openPostAtIndex(this.$store, 0, mediaObjects);
			});
			postElement.setAttribute('role', 'button');
			postElement.setAttribute('tabindex', 0);
			postElement.setAttribute(
				'aria-label',
				`${i18n.t('galleryOpen')} ${mediaObjects.length} ${i18n.t('images')}`
			);
		});
	},
};
